import s from './style.css';
import cn from 'classnames';
import LineWrapper from 'components/LineWrapper';
import TextWithBackground from 'components/TextWithBackground';

const EmojiGraphFaded = ({ data, emoji, emoji2, isEnd, inView }) => {
	const emojiNumber = (respondents, totalRespondents, index) => {
		if (emoji2 && index === 1) {
			emoji = emoji2;
		}
		else {
			emoji;
		}

		let emojiDiv = [];

		for (let i = 0; i < totalRespondents; i++) {
			if (i < respondents) {
				emojiDiv.push(
					<div
						style={{
							transitionDelay: `${i * 0.02}s`
						}}
						className={s.emoji}
					>
						{emoji}
					</div>
				);
			}
			else {
				emojiDiv.push(
					<div
						style={{
							transitionDelay: `${i * 0.02}s`
						}}
						className={cn(s.emoji, s.emojiOpacity)}
					>
						{emoji}
					</div>
				);
			}
		}

		return emojiDiv;
	};

	return (
		<LineWrapper isEnd={isEnd}>
			<div className={cn(s.container, { [s.hidden]: !inView })}>
				{data.map((data, index) => (
					<div className={s.emojiContainer}>
						<TextWithBackground
							tag={'p'}
							bg="transparent"
							highlight={[data.highlight || '']}
							highlightColors={['yellow']}
							className={s.emojiText}
						>
							{data.text}
						</TextWithBackground>
						<div className={s.emojiWrapper}>
							{emojiNumber(data.respondents, data.totalRespondents, index)}
						</div>
					</div>
				))}
			</div>
		</LineWrapper>
	);
};

export default EmojiGraphFaded;



// WEBPACK FOOTER //
// ./components/EmojiGraphFaded/index.js